import CustomSelect from "../protected-page/components/CustomSelect";

export const SelectField = ({ label, disabled, options, value, onChange, onDropdownOpen, required }) => (
  <div>
    <label className="block text-sm text-gray-600 mb-1">
      {label}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
    {disabled ? (
      <div className="text-sm font-medium mt-2">{value?.label || "--"}</div>
    ) : (
      <CustomSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder={`Chọn ${label.toLowerCase()}`}
        onDropdownOpen={onDropdownOpen}
        required={required}
      />
    )}
  </div>
);